//#region src/redux/build/thunk-types.ts
var thunkTypes = { GET_BUILD: `build/getBuild` };
//#endregion
export { thunkTypes };

//# sourceMappingURL=thunk-types.js.map